import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      width: '100%',
    };

    this.accordion = {
      width: '100%',
      borderBottom: (t) => `1px solid ${t.colors.gray}`,
    };

    this.accordionHeader = (isOpen) => ({
      width: '100%',
      py: [4, 6],
      px: 0,
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      ':hover': {
        opacity: 0.7,
      },
    });

    this.accordionHeaderContent = {
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
    };

    this.accordionTitle = {
      variant: 'text.label.1',
      fontSize: ['16px', 2],
      lineHeight: ['22px', 18],
      fontWeight: 500,
    };

    this.accordionIcon = (isOpen) => ({
      width: '16px',
      height: '16px',
      transition: 'transform 0.2s ease-in-out',
      transform: 'rotate(0deg)',
    });

    this.accordionContent = (isOpen) => ({
      width: '100%',
      overflow: 'hidden',
      transition: 'max-height 0.3s ease-in-out, opacity 0.2s ease-in-out',
      maxHeight: isOpen ? '1000px' : '0px',
      opacity: isOpen ? 1 : 0,
      'p, span': {
        fontSize: ['16px', '15px'],
        lineHeight: ['22px', '19px'],
      },
    });
  })()
);
